const statusMap = {
    empty: 'empty',
    published: 'active',
    unpublished: 'inactive',
};

const Tour = ({
    vrModelId = '',
    vrModelGuid = '',
    revisionId = '',
    label = '',
    createDateTimeUtc = '',
    creatorName = '',
    posterUrl = '',
    tourUrl = '',
    status = 'empty',
} = {}) => ({
    id: String(vrModelId),
    guid: String(vrModelGuid),
    revisionId: String(revisionId),
    name: String(label),
    createdDate: String(createDateTimeUtc),
    creatorName: String(creatorName),
    imageSrc: String(posterUrl),
    src: String(tourUrl),
    state: statusMap[status],
});

export default Tour;
